/* eslint-disable no-template-curly-in-string */
import TextArea from 'antd/es/input/TextArea';
import React from 'react';
import Box from '../../../components/Box';
import styled from 'styled-components';
import { Tag } from 'antd';

type TextAreaSuggestInputProps = {
  value?: string;
  onChange?: (value: string) => void;
};

const TextAreaSuggestInput = ({ value, onChange }: TextAreaSuggestInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  const handleTagClick = (tag: string) => {
    const newValue = value ? `${value}${tag}` : tag;
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <Box display='flex' flexDirection='column' gap={1}>
      <TextArea
        placeholder='Enter message..'
        autoSize={{ minRows: 3, maxRows: 10 }}
        value={value}
        onChange={handleChange}
        showCount
        count={{ max: 500 }}
        maxLength={500}
      />
      <Box display='flex' flexWrap='wrap' style={{ gap: 8 }}>
        <TagStyled onClick={() => handleTagClick('${customerName}')}>Customer name</TagStyled>
        <TagStyled onClick={() => handleTagClick('${businessName}')}>Business name</TagStyled>
        <TagStyled onClick={() => handleTagClick('${serviceName}')}>Service name</TagStyled>
        <TagStyled onClick={() => handleTagClick('${linkCoupon}')}>Link coupon</TagStyled>
        <TagStyled onClick={() => handleTagClick('${birthday}')}>Birthday</TagStyled>
      </Box>
    </Box>
  );
};

export default TextAreaSuggestInput;

const TagStyled = styled(Tag)`
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  border-radius: 20px;
  padding: 5px 13px;
  background: rgba(197, 221, 248, 1);
  font-weight: 400;
  font-size: 15px;
  text-align: center;
  cursor: alias;
  margin: 0;
`;
